import MaintenanceModePage from 'app/BCKSPage/MaintenanceMode'
import QualificationCheckPage from 'app/BCKSPage/QualificationCheckPage'
import { isToggleEnabled } from 'configs/toggle-feature'

interface PropsQualificationCheckPage {
  isKSSelectionEnabled: boolean
  isKSSeleksiTertutupEnabled: boolean
}

export const getServerSideProps = async () => {
  const isKSSelectionEnabled = await isToggleEnabled('ks-selection-enabled')
  const isKSSeleksiTertutupEnabled = await isToggleEnabled(
    'ks-selection-seleksi-tertutup-enabled'
  )

  return {
    props: {
      isKSSelectionEnabled,
      isKSSeleksiTertutupEnabled,
    },
  }
}

const QualificationCheckPageIndex = (props: PropsQualificationCheckPage) => {
  if (!props.isKSSelectionEnabled) {
    return <MaintenanceModePage />
  }

  return (
    <QualificationCheckPage
      isKSSeleksiTertutupEnabled={props.isKSSeleksiTertutupEnabled}
    />
  )
}

// eslint-disable-next-line react/display-name
QualificationCheckPageIndex.Layout = ({ children }) => children

export default QualificationCheckPageIndex
